export const getJustifyContent = (showNeighborhood, itemsPerRow, gap) => {
    if (itemsPerRow === 1)
        return 'center';
    if (showNeighborhood)
        return 'flex-start';
    if (gap)
        return 'center';
    return 'space-around';
};
export const getRowGap = (rowGap, gap) => {
    if (rowGap)
        return `${rowGap}px`;
    if (gap)
        return `${gap}px`;
    return '32px';
};
//# sourceMappingURL=helper.js.map